// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S_Kcr","col":"styles_col__HFr6b"};